export default __webpack_public_path__ + "static/media/hand_pointer.aa405266.svg";